import React from 'react';
import { LinearProgress } from '@material-ui/core';

import DeliveryTruck from 'components/Common/Icons/DeliveryTruck';
import TriangleDown from 'components/Common/Icons/TriangleDown';
import { formatPrice } from 'services/formatter';

import styles from './FreeShippingThreshold.module.scss';

type FreeShippingThresholdProps = {
  classes?: { container?: string };
  message: string;
  amount: number;
  percentage: number;
};

function FreeShippingThreshold({
  classes,
  message,
  amount,
  percentage,
}: FreeShippingThresholdProps): JSX.Element {
  return (
    <div className={classes?.container}>
      <div className={styles.thresholdInformation}>
        <div className={styles.thresholdMessageWrapper}>
          <div
            className={styles.thresholdMessage}
            dangerouslySetInnerHTML={{ __html: message }}
          />
          <DeliveryTruck className={styles.truckIcon} />
        </div>
        <div className={styles.thresholdAmount}>
          <span className={styles.thresholdAmountPrice}>
            {formatPrice(amount, true)}
          </span>
          <TriangleDown className={styles.thresholdAmountIcon} />
        </div>
      </div>
      <LinearProgress
        variant="determinate"
        value={percentage}
        classes={{
          root: styles.progressBarWrapper,
          barColorPrimary: styles.progressBar,
        }}
      />
    </div>
  );
}

export default FreeShippingThreshold;
